export const BED_IPD_DASHBOARD_URL = '/bedIpd/ipVisit/dashboard'
export const IP_VISIT_VITALS_URL = '/visits/ipdVisit/'
export const USER_CREATATION = '/administration/userCreation'
export const Edit = 'edit'
export const Create = 'create'
export const doctor = '/administration/doctors'
export const partners = '/administration/referredOut'
export const radilogist = '/administration/radiologist'
export const proRithmDashboard = '/proRithmDashboard'
export const pathologist = 'administration/pathologist'
export const labDevices = '/labDevices'
export const radiologyDevices = '/radiologyDevices'
export const editABMembership = '/ab/membership-edit'
export const ABMemberDashboard = '/ab/membership-dashboard/'
export const ABMemebrship = '/ab/membership'
export const labordercreate = '/lms/search/createorder'
export const laborercollect = '/lms/search/collect/'
export const KEYCLOCK_ROLES = 'keyclock/roles'
export const registration = '/patient-registration'
export const searchpatient = 'api/fhir/Patient?identifier='
export const userCreation = '/userdata'
export const keycloakRoleRemoval = 'api/ipd/keycloak/removeRole?id='
export const BackLogOrders = 'api/api/rest/backlogordersonview-backlogdata'
export const CurrentOrders = 'api/api/rest/backlogordersonview-currentdata'
export const getWardsAndBeds = 'api/api/rest/wards/beds'
export const getBedsByLocation = 'api/api/rest/beds/location'
export const getAllLabDepartmentsEndpoint = 'api/api/rest/departments'
export const labDeviceModel = '/labDeviceModel'
export const AllCompanies = 'api/api/rest/get-company'
export const UpdateLablocation = 'api/laborders/v1/update'
export const orderinvoice = '/orderinvoice'
export const labDashboard = '/lms'
export const parameterMappings = '/labDeviceModel/Parameters'
export const visits = '/visits'
